import { Time } from "@angular/common";

export class SelectedSessionDate {
  startDate: Date;
  startTime: Time;
  endTime: Time;

  constructor(startDate?: any, startTime?: Time, endTime?: Time) {
    if (startDate && startTime && endTime) {
      this.startDate = startDate;
      this.startTime = startTime;
      this.endTime = endTime;
    }
  }
}
